/* ══════════════════════════════════════════════════════════════════
   Felix & Lassie — envoi de la photo
   ══════════════════════════════════════════════════════════════════

   Machine à états qui converge TOUJOURS vers « vendable » :

     vide ──choix──► [conversion HEIC] ──► envoi ──┬─► reçue
                                                    └─► échec
                                                        (la vente passe)

   ─── CE QUI EST INTERDIT ICI ────────────────────────────────────
   Toucher au bouton « Ajouter au panier ». Pas de `disabled`, pas de
   `required`, aucune interception de la soumission. Si l'envoi échoue,
   `_photo_statut` reste à `a_demander` et le flux email prend le relais.

   ─── SANS CE SCRIPT ─────────────────────────────────────────────
   Tous les états restent `hidden` (posé dans le Liquid) sauf
   l'échappatoire : le client lit « je l'envoie après la commande » et
   la vente passe. C'est un repli volontaire, pas un accident.

   ─── STOCKAGE ───────────────────────────────────────────────────
   `data-fl-endpoint` sur le bloc donne l'URL du service qui signe
   l'envoi. Absent, le bloc reste en mode « après la commande » — ce
   qui permet de mettre la boutique en ligne avant que le stockage
   existe.
   ══════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var TIMEOUT_MS = 20000;   // au-delà, on n'attend plus : la vente prime
  var COTE_MAX = 2400;      // redimensionnement avant envoi
  var APERCU_MAX = 600;

  function uuid() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  /* Le HEIC n'est décodé par AUCUN navigateur, Safari inclus — et sur iOS
     `file.type` est souvent une chaîne vide. On ne se fie donc jamais au
     seul mimetype. */
  function estHeic(f) {
    var n = (f.name || '').toLowerCase();
    return /\.(heic|heif)$/.test(n) || f.type === 'image/heic' || f.type === 'image/heif';
  }

  function litImage(fichier) {
    return new Promise(function (res, rej) {
      var url = URL.createObjectURL(fichier);
      var img = new Image();
      img.onload = function () { res({ img: img, url: url }); };
      img.onerror = function () { URL.revokeObjectURL(url); rej(new Error('illisible')); };
      img.src = url;
    });
  }

  function redimensionner(img, coteMax, qualite) {
    var w = img.naturalWidth, h = img.naturalHeight;
    var f = Math.min(1, coteMax / Math.max(w, h));
    var c = document.createElement('canvas');
    c.width = Math.round(w * f);
    c.height = Math.round(h * f);
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    return new Promise(function (res) {
      c.toBlob(function (b) { res(b); }, 'image/jpeg', qualite || 0.86);
    });
  }

  function init(racine) {
    var champ = racine.querySelector('[data-fl-fichier]');
    // Le configurateur peut avoir sorti l'echappatoire du bloc pour la
    // garder visible a toutes les etapes : on la cherche donc aussi a
    // cote, jamais uniquement a l'interieur.
    function trouverApres() {
      return racine.querySelector('[data-fl-apres]')
          || (racine.parentNode && racine.parentNode.querySelector('[data-fl-apres]'))
          || document.querySelector('[data-fl-apres]');
    }
    if (!champ) return;

    var hidden = {
      token: racine.querySelector('[data-fl-token]'),
      url: racine.querySelector('[data-fl-url]'),
      statut: racine.querySelector('[data-fl-statut]'),
      format: racine.querySelector('[data-fl-format]')
    };

    // Le token est posé AVANT tout envoi : une photo qui arrive plus tard
    // retombe exactement au même endroit.
    var token = uuid();
    if (hidden.token) hidden.token.value = token;

    var endpoint = racine.getAttribute('data-fl-endpoint') || '';
    var maxOctets = (parseInt(racine.getAttribute('data-fl-max-mo'), 10) || 20) * 1024 * 1024;

    function etat(nom) {
      Array.prototype.forEach.call(
        racine.querySelectorAll('[data-fl-etat]'),
        function (z) { z.hidden = z.getAttribute('data-fl-etat') !== nom; }
      );
      // L'echappatoire disparait uniquement quand la photo est bien la.
      var apres = trouverApres();
      if (apres) apres.hidden = nom === 'recue';
    }

    /**
     * Affiche ce que le gate a trouvé.
     *
     * Un refus dit ce qui ne va pas ET ce qu'il faut faire — sans quoi le
     * client bloque et abandonne. Un avertissement se contente d'un
     * conseil : la photo passe quand même.
     */
    function afficherConstats(verdict) {
      var zone = racine.querySelector('[data-fl-constats]');
      if (!zone) return;

      if (!verdict.constats.length) {
        zone.hidden = true;
        zone.textContent = '';
        return;
      }

      // Sur un refus, seuls les constats bloquants comptent : afficher en
      // plus des conseils secondaires noierait le message.
      var refus = verdict.verdict === 'refuse';
      var aMontrer = refus
        ? verdict.constats.filter(function (c) { return c.gravite === 'refuse'; })
        : verdict.constats;

      zone.innerHTML = aMontrer.map(function (c) {
        return '<p class="fl-upload__constat' + (refus ? ' fl-upload__constat--refus' : '') + '">'
          + '<strong>' + c.message + '</strong><br>' + c.conseil + '</p>';
      }).join('');
      zone.hidden = false;
    }

    function marquer(statut, url, format) {
      if (hidden.statut) hidden.statut.value = statut;
      if (hidden.url) hidden.url.value = url || '';
      if (hidden.format) hidden.format.value = format || '';
    }

    function echec() {
      marquer('a_demander', '', '');
      etat('echec');
    }

    async function traiter(fichier) {
      if (!fichier) return;

      if (fichier.size > maxOctets) { echec(); return; }

      etat('encours');
      var nomEl = racine.querySelector('[data-fl-nom]');
      if (nomEl) nomEl.textContent = fichier.name || '';

      var format = '';
      var aEnvoyer = fichier;

      try {
        if (estHeic(fichier)) {
          // On tente la conversion, mais on n'en dépend pas : si elle
          // échoue, on envoie le HEIC brut et le serveur convertira.
          format = 'heic';
          try {
            var mod = await import('https://cdn.jsdelivr.net/npm/heic2any@0.0.4/+esm');
            var conv = await mod.default({ blob: fichier, toType: 'image/jpeg', quality: 0.9 });
            aEnvoyer = Array.isArray(conv) ? conv[0] : conv;
            format = '';
          } catch (e) { /* on garde le fichier d'origine */ }
        }

        // Aperçu + réduction. Un HEIC non converti n'est pas décodable :
        // on saute cette étape sans considérer que c'est un échec.
        try {
          var lu = await litImage(aEnvoyer);

          // ── Le gate photo ────────────────────────────────────────
          // L'image est décodée : la mesurer ne coûte rien de plus, et
          // le client sait tout de suite si sa photo pose problème —
          // avant de payer, pas trois jours après.
          //
          // Le gate ne refuse que l'irrattrapable (flou de bougé,
          // vignette, noir complet). Tout le reste passe avec un conseil :
          // avant paiement, trop strict = ventes perdues.
          if (window.FLGate) {
            var verdict = window.FLGate.evaluer(window.FLGate.mesurer(lu.img));
            afficherConstats(verdict);
            if (verdict.verdict === 'refuse') {
              URL.revokeObjectURL(lu.url);
              // Le bouton panier reste actif : le client peut acheter et
              // envoyer une autre photo ensuite, par le lien email.
              etat('vide');
              return;
            }
          }

          var apercu = await redimensionner(lu.img, APERCU_MAX, 0.8);
          var urlApercu = URL.createObjectURL(apercu);
          ['[data-fl-vignette]', '[data-fl-vignette-ok]'].forEach(function (sel) {
            var el = racine.querySelector(sel);
            if (el) el.src = urlApercu;
          });
          var reduit = await redimensionner(lu.img, COTE_MAX, 0.86);
          if (reduit && reduit.size < aEnvoyer.size) aEnvoyer = reduit;
          URL.revokeObjectURL(lu.url);
        } catch (e) { /* pas d'aperçu, ce n'est pas bloquant */ }

        if (!endpoint) {
          // Pas encore de stockage : on assume le parcours « après la
          // commande » plutôt que de simuler une réussite.
          echec();
          return;
        }

        var barre = racine.querySelector('[data-fl-progres]');
        if (barre) barre.style.width = '35%';

        var ctrl = new AbortController();
        var minuteur = setTimeout(function () { ctrl.abort(); }, TIMEOUT_MS);

        var rep = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            token: token,
            nom: fichier.name || '',
            type: aEnvoyer.type || 'image/jpeg'
          }),
          signal: ctrl.signal
        });
        if (!rep.ok) throw new Error('presign');
        var infos = await rep.json();

        if (barre) barre.style.width = '70%';

        var envoi = await fetch(infos.uploadUrl, {
          method: 'PUT',
          body: aEnvoyer,
          headers: { 'Content-Type': aEnvoyer.type || 'image/jpeg' },
          signal: ctrl.signal
        });
        clearTimeout(minuteur);
        if (!envoi.ok) throw new Error('put');

        if (barre) barre.style.width = '100%';
        marquer('recue', infos.publicUrl, format);
        etat('recue');
      } catch (e) {
        echec();
      }
    }

    champ.addEventListener('change', function () {
      traiter(champ.files && champ.files[0]);
    });

    var rechoisir = racine.querySelector('[data-fl-rechoisir]');
    if (rechoisir) rechoisir.addEventListener('click', function () {
      champ.value = '';
      marquer('a_demander', '', '');
      etat('vide');
    });

    var reessayer = racine.querySelector('[data-fl-reessayer]');
    if (reessayer) reessayer.addEventListener('click', function () {
      champ.value = '';
      etat('vide');
    });

    // C'est ici, et seulement ici, que l'état vide devient visible.
    etat('vide');
  }

  function demarrer() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fl-upload]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
  document.addEventListener('shopify:section:load', demarrer);
})();
